<template>
    <div class="home-box">
      <v-row>       
        <div class="col-md-12 home-tabs-body pa-5">
          <Breadcrumbs :title="'Calendar'"></Breadcrumbs>
          <Calendar></Calendar>
        </div>
      </v-row>
    </div>
  </template>
  
  <script>
  import Calendar from "@/components/calendar/Calendar";
  import { createNamespacedHelpers } from "vuex";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "",
    components: {
      Calendar,
      Breadcrumbs
    },
    data: function () {
      return {
        role: localStorage.getItem('role') || null,
        editMode: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        profile: "profile",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
    }
  };
  </script>
  